class Conference {
    init() {
        $(document).on('change', '#has-sections', function(){
            let subHarvests = $('.sections');
            if($(this).is(':checked')){
                subHarvests.slideDown();
            } else {
                subHarvests.slideUp();
            }
        })

        let sectionsRowID = 1;
        $(document).on('click', '.add-section, .remove-section', function() {
            let currentRow = $(this).closest('.section-row');
            let rowsCount = $('.section-row').length;

            if($(this).hasClass('remove-section')){
                if(rowsCount <= 1) {
                    Toast.fire({
                        icon: 'info',
                        title: 'There must be, at least, one Section. To disable sections uncheck the "Has Sections" switch'
                    })
                } else {
                    currentRow.slideUp(function(){
                        currentRow.remove();
                        if(sectionsRowID > 1){
                            sectionsRowID--;
                        }
                    });
                }
                return false;
            }

            let newRow = `
            <div class="input-group input-group mb-3 section-row">
                <button class="btn bg-gradient-dark shadow-none" type="button">Title</button>
                <input type="text" class="form-control px-2" name="section[${sectionsRowID}][title]" placeholder="E.g.: Art Class">
                <button class="btn bg-gradient-danger shadow-none remove-section" type="button"><span class="fas fa-minus"></span></button>
                <button class="btn bg-gradient-success shadow-none add-section" type="button"><span class="fas fa-plus"></span></button>
            </div>
           `;

            currentRow.after(newRow)
            sectionsRowID++;
        });

        $(document).on('change', '#has-fees', function(){
            let subHarvests = $('.fees');
            if($(this).is(':checked')){
                subHarvests.slideDown();
            } else {
                subHarvests.slideUp();
            }
        })

        let feesRowID = 1;
        $(document).on('click', '.add-fee, .remove-fee', function() {
            let currentRow = $(this).closest('.fee-row');
            let rowsCount = $('.fee-row').length;

            if($(this).hasClass('remove-fee')){
                if(rowsCount <= 1) {
                    Toast.fire({
                        icon: 'info',
                        title: 'There must be, at least, one Fee. To disable fees uncheck the "Include other Fees" switch'
                    })
                } else {
                    currentRow.slideUp(function(){
                        currentRow.remove();
                        if(feesRowID > 1){
                            feesRowID--;
                        }
                    });
                }
                return false;
            }

            let newRow = `
            <div class="input-group input-group-sm mb-3 fee-row">
                <button class="btn bg-gradient-dark shadow-none" type="button">Title</button>
                <input type="text" class="form-control px-2" name="fee[${feesRowID}][title]" placeholder="E.g.: Registration Fee">
                <button class="btn bg-gradient-dark shadow-none" type="button">(GH¢)</button>
                <input type="number" step=".01" class="form-control px-2" name="fee[${feesRowID}][amount]" placeholder="E.g.: 125.00">
                <button class="btn bg-gradient-danger shadow-none remove-fee" type="button"><span class="fas fa-minus"></span></button>
                <button class="btn bg-gradient-success shadow-none add-fee" type="button"><span class="fas fa-plus"></span></button>
            </div>
           `;

            currentRow.after(newRow)
            feesRowID++;
        });
    }
}

export default Conference.prototype
